import { useEffect } from 'react';
import { Studio } from './components/studio';
import { useAuthorizationManager } from '@hooks/authorization';
import { StudioContextProvider } from '@components/studioContextProvider';
import { FeaturesProvider } from './hooks/useFeatures';

function App() {
  const { authContext } = useAuthorizationManager();

  useEffect(() => {
    if (authContext && !authContext.isAuthenticated) {
      authContext.redirectToLogin();
    }
  }, [authContext]);

  const editor = (
    <StudioContextProvider>
      <Studio />
    </StudioContextProvider>
  );

  return (
    <FeaturesProvider>
      <div className="App">
        {authContext && authContext.isAuthenticated && editor}
      </div>
    </FeaturesProvider>
  );
}

export default App;
